import { render } from "./Reestor.vue?vue&type=template&id=1d15fe22&scoped=true"
import script from "./Reestor.vue?vue&type=script&lang=js"
export * from "./Reestor.vue?vue&type=script&lang=js"

import "./Reestor.vue?vue&type=style&index=0&id=1d15fe22&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d15fe22"]])

export default __exports__